import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { PurchaseRequestDocumentUploadItemResult } from '../interfaces/purchase-request-document-upload-item-result';
import {
  AbstractPurchaseRequestDocumentService,
  PurchaseRequestDocumentUploadPayload
} from './abstract-purchase-request-document-upload.service';
import { AbstractPurchasingService } from './abstract-purchasing.service';

@Injectable({
  providedIn: 'root',
})
export class PurchaseRequestDocumentService extends AbstractPurchaseRequestDocumentService {
  private readonly purchasingService = inject(AbstractPurchasingService);

  uploadDocuments(
    payload: PurchaseRequestDocumentUploadPayload
  ): Observable<PurchaseRequestDocumentUploadItemResult[]> {
    const { purchaseId, supplierId, spreadsheetFile, supplierQuoteFile } = payload;

    return this.purchasingService.uploadOfferDocuments({
      purchaseId,
      supplierId,
      spreadsheetFile,
      supplierQuoteFile
    });
  }

  downloadDocuments(purchaseId: string, supplierId: string): Observable<Blob> {
    return this.purchasingService.downloadSupplierQuoteFile(purchaseId, supplierId);
  }
}
